const screenshotUrls = {
  carnetDeNotes: 'screenshots/capture-ecran-carnet-de-notes-1.png',
  trombinoscope: 'screenshots/capture-ecran-trombinoscope-1.png',
  livret: 'screenshots/capture-ecran-livrets-lsu-1.png',
  cahierJournal: 'screenshots/capture-ecran-cahier-journal.png',
  registreAppel: 'screenshots/capture-ecran-registre-appel-1.png',
  pyramideDesAges: 'screenshots/capture-ecran-pyramide-des-ages-1.png',
} as const;

export { screenshotUrls };
